import React from 'react';
import { Line } from 'react-chartjs-2';

const AreaPanel = ({ areaChartData, areaChartOptions, delay }) => {
  return (
    <div className="panel area-panel" style={{ animationDelay: delay }}>
      <div className="ph">
        <div className="pt">
          <div className="pdot" style={{ background: '#22c55e', boxShadow: '0 0 0 2px rgba(34,197,94,.2)' }}></div>
          Energy Trend — Monthly
        </div>
      </div>
      <div className="chart-legends">
        <div className="cl">
          <div className="cl-line" style={{ background: '#22c55e' }}></div>
          Consumption
        </div>
        <div className="cl">
          <div className="cl-line" style={{ background: '#3b82f6' }}></div>
          Generation
        </div>
      </div>
      <div className="area-body">
        <Line data={areaChartData} options={areaChartOptions} />
      </div>
    </div>
  );
};

export default AreaPanel;
